// extracted by mini-css-extract-plugin
export default {"holiday-details-list":"HolidayDetails_holiday-details-list__1YsNu"};